// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");